import { AppState } from 'modules'
import { availabilitySelectors } from 'modules/ticketing/availability/availabilitySlice'

export const selectIsTicketDataLoading = (state: AppState) =>
  state.ticketing.performance.fetchOneStatus === 'pending' ||
  state.ticketing.performance.fetchManyStatus === 'pending' ||
  state.seatMap.loading ||
  availabilitySelectors.selectIsLoading(state)
